import { useLocation } from 'react-router-dom';

const useMainPath = () => {
    const location = useLocation();
    const parts = location.pathname.split('/');
    return parts.length > 1 ? `/${parts[1]}` : '/';
};

export default useMainPath;